<template>
  <div class="mb-4" :class="containerClasses" :style="{ width }">
    <label v-if="label" class="mb-1 block text-sm font-medium text-foreground">
      {{ label }}
      <span v-if="required" class="text-destructive">*</span>
    </label>

    <div class="relative">
      <div v-if="iconLeft" class="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-muted-foreground">
        <slot name="icon-left"></slot>
      </div>

      <UiSelect
        v-if="type === 'select'"
        :model-value="modelValue"
        @update:modelValue="$emit('update:modelValue', $event)"
        :required="required"
        :disabled="disabled"
        :select-class="[
          iconLeft ? 'pl-10' : '',
          iconRight ? 'pr-10' : '',
          error ? 'border-destructive focus-visible:ring-destructive' : '',
          inputClass
        ]"
      >
        <option v-if="placeholder" value="" disabled>{{ placeholder }}</option>
        <option v-for="option in options" :key="option.value || option" :value="option.value || option">
          {{ option.label || option }}
        </option>
      </UiSelect>

      <UiInput
        v-else
        :model-value="modelValue"
        @update:modelValue="$emit('update:modelValue', $event)"
        :type="type"
        :placeholder="placeholder"
        :required="required"
        :disabled="disabled"
        :min="min"
        :max="max"
        :step="step"
        :input-class="[
          iconLeft ? 'pl-10' : '',
          iconRight ? 'pr-10' : '',
          error ? 'border-destructive focus-visible:ring-destructive' : '',
          inputClass
        ]"
      />

      <div v-if="iconRight" class="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3 text-muted-foreground">
        <slot name="icon-right"></slot>
      </div>
    </div>

    <p v-if="error" class="mt-1 text-sm text-destructive">{{ error }}</p>
    <p v-else-if="helpText" class="mt-1 text-sm text-muted-foreground">{{ helpText }}</p>
  </div>
</template>

<script>
import { Input as UiInput } from './ui/input';
import { Select as UiSelect } from './ui/select';

export default {
  name: 'FormInput',
  components: {
    UiInput,
    UiSelect
  },
  props: {
    modelValue: [String, Number, Date],
    type: {
      type: String,
      default: 'text',
    },
    label: String,
    placeholder: String,
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
    helpText: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: '100%',
    },
    iconLeft: {
      type: Boolean,
      default: false,
    },
    iconRight: {
      type: Boolean,
      default: false,
    },
    min: {
      type: [String, Number],
      default: null,
    },
    max: {
      type: [String, Number],
      default: null,
    },
    step: {
      type: [String, Number],
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    inputClass: {
      type: String,
      default: '',
    },
    containerClasses: {
      type: String,
      default: '',
    },
  },
};
</script>
